import { render, staticRenderFns } from "./theme-no-data-img.vue?vue&type=template&id=581a33f6&scoped=true"
import script from "./theme-no-data-img.vue?vue&type=script&lang=js"
export * from "./theme-no-data-img.vue?vue&type=script&lang=js"
import style0 from "./theme-no-data-img.vue?vue&type=style&index=0&id=581a33f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a33f6",
  null
  
)

export default component.exports